<template>
  <div v-if="showOverlayModalPinia">
    <ModalCreateTicket
      v-if="currentOverlayModalPinia === 'createTicket'"
      @closeCreateTicketModal="closeModal()"
    />
    <ModalEditTicket
      v-if="currentOverlayModalPinia === 'editTicket'"
      @closeEditTicketModal="closeModal()"
    />
    <ModalEditLink
      v-if="currentOverlayModalPinia === 'editLink'"
      @closeEditLinkModal="closeModal()"
    />
    <ModalEditPoi v-if="currentOverlayModalPinia === 'editPoi'" @closeEditPoiModal="closeModal()" />
    <ModalCreateAssets
      v-if="currentOverlayModalPinia === 'createAssets'"
      @closeCreateAssetsModal="closeModal()"
    />
    <ModalPreviewFile
      v-if="currentOverlayModalPinia === 'previewFilePinia'"
      @closePreviewFileModal="closeModal()"
    />
    <ModalUploadFiles
      v-if="currentOverlayModalPinia === 'uploadFilesPinia'"
      @closeUploadFilesModal="closeModal()"
    />
    <ModalEditRoom
      v-if="currentOverlayModalPinia === 'editRoomPinia'"
      @closeEditRoomModal="closeModal()"
    />
  </div>
  <!-- Modal on modal was a joint decision on prod/tech review 2024-08-19 -->
  <div v-if="showOverlayModalOnModalPinia">
    <ModalEditLink
      v-if="currentOverlayModalOnModalPinia === 'editTicketLink'"
      @closeEditLinkModal="closeModalOnModal()"
    />
    <ModalPreviewFile
      v-if="currentOverlayModalOnModalPinia === 'previewTicketFilePinia'"
      @closePreviewFileModal="closeModalOnModal()"
    />
    <ModalUploadTicketFiles
      v-if="currentOverlayModalOnModalPinia === 'uploadTicketFiles'"
      @closeUploadFilesModal="closeModalOnModal()"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed, watch } from 'vue'
import { useGeneralStore } from '@/pinia'
import ModalCreateTicket from '@/components/features/tickets/ModalCreateTicket.vue'
import ModalEditTicket from '@/components/features/tickets/ModalEditTicket.vue'
import ModalEditLink from '@/components/features/attachments/ModalEditLink.vue'
import ModalEditPoi from '@/design-system/organisms/ModalEditPoi.vue'
import ModalPreviewFile from '@/components/features/attachments/ModalPreviewFile.vue'
import ModalUploadFiles from '@/components/features/attachments/ModalUploadFiles.vue'
import ModalUploadTicketFiles from '@/components/features/tickets/ModalUploadTicketFiles.vue'
import ModalEditRoom from '@/components/features/info-display/ModalEditRoom.vue'
import ModalCreateAssets from '@/design-system/organisms/ModalCreateAssets.vue'

const piniaStore = useGeneralStore()
const { setShowOverlayModalPinia, setShowOverlayModalOnModalPinia } = useGeneralStore()

const currentOverlayModalPinia = computed(() => {
  return piniaStore.currentOverlayModalPinia
})
const currentOverlayModalOnModalPinia = computed(() => {
  return piniaStore.currentOverlayModalOnModalPinia
})
const showOverlayModalPinia = computed(() => {
  return piniaStore.showOverlayModalPinia
})
const showOverlayModalOnModalPinia = computed(() => {
  return piniaStore.showOverlayModalOnModalPinia
})

function closeModal() {
  setShowOverlayModalPinia(false)
}
function closeModalOnModal() {
  setShowOverlayModalOnModalPinia(false)
}
watch(showOverlayModalPinia, (newValue) => {
  if (!newValue && showOverlayModalOnModalPinia.value) setShowOverlayModalOnModalPinia(false)
})
</script>
<style lang="scss" scoped></style>
